import './src/theme/destyle.css'

import { ThemeProvider } from './src/theme'

export const wrapRootElement = ({ element }) => {
  return <ThemeProvider>{element}</ThemeProvider>
}
